import React from 'react';
import ProjectListItem from './ProjectListItem';
import { Link } from 'react-router-dom';
import { orderBy } from 'lodash';
import { RSLabel } from 'reactsymbols-kit';
import { Bin } from '../Icons';
import IconButton from '../IconButton';
import type { IProject } from '../../stores/projects/project';

/**
 * Render a list of projects
 *
 * Props:
 * - projects: the list of projects to render
 * - emptyMessage: the message to show when the list is empty
 * - onDelete: callback to delete a project
 */
interface ProjectListProps {
  /** The list of projects to render. */
  projects: IProject[];
  /** The message to show when the list is empty. */
  emptyMessage: string;
  /** Callback to delete a project. */
  onDelete: (id: string) => void;
}

const ProjectList = ({ projects, emptyMessage, onDelete }: ProjectListProps) =>
  projects.length > 0 ? (
    <ul className="list-none p-0 m-0 h-[calc(100%-51px)] overflow-auto">
      {orderBy(projects, ['lastActivity'], ['desc']).map(project => {
        return (
          <li key={project.id} className="list-none flex items-center border-b border-grey">
            <Link
              to={project.path}
              className="flex-auto no-underline text-black hover:text-primary-hover hover:[&_svg_*]:fill-primary-hover"
            >
              <ProjectListItem key={project.id} project={project} onDelete={onDelete} />
            </Link>
            <div>
              <IconButton
                className="m-[15px] [&_svg]:h-4 [&_svg]:w-4 [&_svg]:opacity-30 hover:[&_svg]:opacity-100"
                onClick={() => {
                  onDelete(project.id);
                }}
              >
                <Bin />
              </IconButton>
            </div>
          </li>
        );
      })}
    </ul>
  ) : (
    <div className="empty flex-1 flex items-center justify-center">
      <RSLabel text={emptyMessage} />
    </div>
  );

export default ProjectList;
